import { createFileRoute } from '@tanstack/react-router'

import { RolesList } from '@/access-control/components/RolesList/RolesList'
import { FEATURE_ROLES_OVERVIEW } from '@/core/constants/features'
import useFeatures from '@/core/utils/features/useFeatures'

export const Route = createFileRoute('/company/_management/settings/roles')({
  component: RouteComponent,
})

function RouteComponent() {
  const hasCompanyRolesFeature = useFeatures(FEATURE_ROLES_OVERVIEW)

  if (!hasCompanyRolesFeature) {
    return null
  }

  return <RolesList />
}
